export const ANALYTICS_NOTES_YEARLY = 'analyticsNotes';

export const ANALYTICS_NOTES_YEARLY_ACTIONS_NAME = {
  searchForeignTradeTemplateData: `${ANALYTICS_NOTES_YEARLY}/searchForeignTradeTemplateData`,
  searchForeignTradeTable: `${ANALYTICS_NOTES_YEARLY}/searchForeignTradeTable`,
  searchExportStructureTable: `${ANALYTICS_NOTES_YEARLY}/searchExportStructureTable`,
  searchImportStructureTable: `${ANALYTICS_NOTES_YEARLY}/searchImportStructureTable`,
  searchExportProductsTable: `${ANALYTICS_NOTES_YEARLY}/searchExportProductsTable`,
  searchImportProductsTable: `${ANALYTICS_NOTES_YEARLY}/searchImportProductsTable`,
} as const;

export const ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME = {
  setForeignTradeTemplateData: `${ANALYTICS_NOTES_YEARLY}/setForeignTradeTemplateData`,
  setForeignTradeTable: `${ANALYTICS_NOTES_YEARLY}/setForeignTradeTable`,
  setExportStructureTable: `${ANALYTICS_NOTES_YEARLY}/setExportStructureTable`,
  setImportStructureTable: `${ANALYTICS_NOTES_YEARLY}/setImportStructureTable`,
  setExportProductsTable: `${ANALYTICS_NOTES_YEARLY}/setExportProductsTable`,
  setImportProductsTable: `${ANALYTICS_NOTES_YEARLY}/setImportProductsTable`,
} as const;

export const ANALYTICS_NOTES_YEARLY_GETTERS_NAME = {
  getForeignTradeTemplateData: `${ANALYTICS_NOTES_YEARLY}/getForeignTradeTemplateData`,
  getForeignTradeTable: `${ANALYTICS_NOTES_YEARLY}/getForeignTradeTable`,
  getExportStructureTable: `${ANALYTICS_NOTES_YEARLY}/getExportStructureTable`,
  getImportStructureTable: `${ANALYTICS_NOTES_YEARLY}/getImportStructureTable`,
  getExportProductsTable: `${ANALYTICS_NOTES_YEARLY}/getExportProductsTable`,
  getImportProductsTable: `${ANALYTICS_NOTES_YEARLY}/getImportProductsTable`,
} as const;
